module.exports = __webpack_public_path__ + "static/media/dashboard-icon.91617a1f.svg";